<script setup lang="ts">
import { formatMoney, formatPickup } from '../format';
import type { PdsOrder } from '../types';
import PaperTicket from './PaperTicket.vue';

defineProps<{ order: PdsOrder; store: string; city: string }>();
</script>

<template>
  <PaperTicket>
    <div class="text-center">
      <p class="font-bold uppercase">{{ store }}</p>
      <p v-if="city">{{ city }}</p>
    </div>
    <hr class="my-[10px] h-[3px] border-0 bg-[#1a1a1a]" />
    <div class="text-center">
      <p class="text-[20px] leading-[1.2] font-bold uppercase">
        Commande #{{ order.orderNumber ?? order.number }}
      </p>
      <p v-if="order.label">{{ order.label }}</p>
      <p>Retrait {{ formatPickup(order.dueAt) }}</p>
    </div>
    <hr class="my-[10px] h-[3px] border-0 bg-[#1a1a1a]" />
    <div class="text-center">
      <p class="font-bold uppercase">Code de retrait</p>
      <p class="text-[32px] leading-[1.3] font-bold tracking-[8px]">
        {{ order.pickupCode }}
      </p>
    </div>
    <hr class="my-[10px] h-[3px] border-0 bg-[#1a1a1a]" />

    <p v-for="item in order.items" :key="item.id" class="flex gap-2 py-[3px]">
      <span class="min-w-0 flex-1">{{ item.quantity }} {{ item.name }}</span>
      <b v-if="item.unitPriceCents !== undefined">
        {{ formatMoney(item.unitPriceCents * item.quantity) }}
      </b>
    </p>

    <hr class="my-[10px] h-px border-0 bg-[#1a1a1a]" />
    <p class="flex text-[18px] leading-[1.2] font-bold uppercase">
      Total payé
      <span class="ml-auto">{{ formatMoney(order.totalPaidCents) }}</span>
    </p>
    <hr class="my-[10px] h-[3px] border-0 bg-[#1a1a1a]" />
    <p class="text-center">Merci et à bientôt</p>
  </PaperTicket>
</template>
